<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom:0;">
      <el-row :gutter="15">
        <el-col :md="6" style="margin-bottom: 15px">
          <!-- 数据表格 -->
          <ele-data-table
            ref="table"
            :config="table"
            :current.sync="current"
            @done="done"
            highlight-current-row
            :height="tbHeight"
            class="dict-table"
          >
            <el-table-column type="index" width="45" align="center" />
            <el-table-column prop="groupName" label="请假组名称" show-overflow-tooltip>
              <template #default="{ row }">{{ row.groupName }}</template>
            </el-table-column>
          </ele-data-table>
        </el-col>
        <el-col :md="18" style="margin-bottom: 15px">
          <approvaled v-if="current" :groupId="current.id" :tb-height="tbHeight" />
        </el-col>
        <!--        <el-col :md="9" style="margin-bottom:15px;">-->
        <!--          <approvaled v-if="current" :groupId="current.id" :tb-height="tbHeight"></approvaled>-->
        <!--        </el-col>-->
      </el-row>
    </el-card>
  </div>
</template>

<script>
  // import Approval from "@/views/lea_teacher/approval";
  import Approvaled from '@/views/lea_teacher/approvaled';

  export default {
    name: 'Index',
    components: { Approvaled },
    data() {
      return {
        table: {
          // 表格配置
          url: '/teacherLeave/showCheckGroup',
          page: false,
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        current: null, // 表格选中数据
      };
    },
    computed: {
      /* 表格固定高度 */
      tbHeight() {
        return this.$store.state.theme.screenWidth < 992 ? undefined : 'calc(100vh - 214px)';
      },
    },
    methods: {
      /* 表格渲染完成回调 */
      done(res) {
        if (res.data.length > 0) this.$refs.table.setCurrentRow(res.data[0]);
      },
    },
  };
</script>

<style scoped>
  .dict-table >>> .el-table__row {
    cursor: pointer;
  }

  .dict-table >>> .el-table__row > td:last-child:after {
    content: '\e6e0';
    font-family: element-icons !important;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1;
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -7px;
  }

  .dict-table >>> .el-table__row > td:last-child .cell {
    padding-right: 20px;
  }
</style>
